import React from "react";
import { DIContext } from "./DIContext";
import type { AppContainer } from "./AppContainer";

export function DIProvider({
  value,
  children,
}: {
  value: AppContainer;
  children: React.ReactNode;
}) {
  return <DIContext.Provider value={value}>{children}</DIContext.Provider>;
}
